export const SIGN_IN_TEST_IDS = {
  identifierSubmitButton: 'auth-identifier-submit',
  passwordSubmitButton: 'auth-password-submit',
  productCompanyOption: 'auth-product-company',
  productPortfolioOption: 'auth-product-portfolio',
} as const;
